/* DO NOT MODIFY. This is an autogenerated file. */
/* eslint-disable */
import * as React from "react"
import type { SVGProps } from "react"

export const SvgRectangle01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "100%"}
    height={props.height || "100%"}
    fill="none"
    viewBox="0 0 134 20"
    data-name="SvgRectangle01"
    {...props}
  >
    {props.children}
    <path
      fill="#fff"
      d="M0 10C0 4.477 4.477 0 10 0h114.524c.584 0 1.14.256 1.52.7L134 10l-7.956 9.3c-.38.444-.936.7-1.52.7H10C4.477 20 0 15.523 0 10"
    />
    <path
      fill="#fff"
      fillOpacity={0.2}
      d="M0 10C0 4.477 4.477 0 10 0h114.524c.584 0 1.14.256 1.52.7L134 10l-7.956 9.3c-.38.444-.936.7-1.52.7H10C4.477 20 0 15.523 0 10"
    />
  </svg>
)
